export default __webpack_public_path__ + "72c55b42ac78df2d581af7ebd811f9d3.png";